<div class="max-w-6xl">
  <div class="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
    <div class="max-w-2xl">
      <h1 class="text-4xl font-extrabold tracking-tight text-gray-900">{{ headline }}</h1>
      <p class="mt-3 text-lg text-gray-600">
        Based on your venue type and 501(c)(3) status. Switch any time &mdash; no card today,
        billing starts after your first event.
      </p>
    </div>
    <div class="inline-flex shrink-0 items-center self-start rounded-full bg-gray-100 p-1">
      <button
        type="button"
        class="rounded-full px-5 py-2 text-sm font-semibold transition-colors"
        [ngClass]="isAnnual ? 'bg-white text-gray-900 shadow' : 'text-gray-500 hover:text-gray-700'"
        (click)="setPricing(true)"
      >
        Yearly &middot; save up to 14%
      </button>
      <button
        type="button"
        class="rounded-full px-5 py-2 text-sm font-semibold transition-colors"
        [ngClass]="!isAnnual ? 'bg-white text-gray-900 shadow' : 'text-gray-500 hover:text-gray-700'"
        (click)="setPricing(false)"
      >
        Monthly
      </button>
    </div>
  </div>

  <div class="mt-10 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
    <div *ngFor="let p of plans" class="relative">
      <span
        *ngIf="p.name === recommendedPlanName"
        class="absolute -top-3 left-1/2 z-10 -translate-x-1/2 whitespace-nowrap rounded-full bg-red-700 px-4 py-1 text-xs font-bold uppercase tracking-widest text-white"
      >Recommended</span>
      <button
        type="button"
        (click)="onSelectPlan(p)"
        class="flex h-full w-full flex-col rounded-xl border p-6 text-left transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-700"
        [ngClass]="selectedPlanName === p.name
          ? 'border-red-700 bg-red-50 ring-1 ring-red-700'
          : 'border-gray-300 bg-white hover:border-gray-400'"
        [attr.aria-pressed]="selectedPlanName === p.name"
      >
        <span
          class="text-xs font-semibold uppercase tracking-widest"
          [ngClass]="selectedPlanName === p.name ? 'text-red-700' : 'text-gray-500'"
        >{{ p.displayName }}</span>
        <span class="mt-3 flex items-baseline gap-1">
          <span class="text-4xl font-extrabold text-gray-900">${{ displayedPrice(p) }}</span>
          <span *ngIf="displayedPrice(p) !== '0'" class="text-sm text-gray-500">/mo</span>
        </span>
        <span class="mt-3 flex-1 text-sm leading-relaxed text-gray-600">{{ p.summary }}</span>
        <span
          class="mt-5 block w-full rounded-lg px-4 py-2.5 text-center text-base font-bold transition-colors"
          [ngClass]="selectedPlanName === p.name
            ? 'bg-red-700 text-white'
            : 'border border-gray-300 bg-white text-gray-900'"
        >{{ selectedPlanName === p.name ? 'Keep ' + p.displayName : 'Choose ' + p.displayName }}</span>
      </button>
    </div>
  </div>

  <p class="mt-4 text-xs text-gray-400">
    <ng-container *ngIf="isAnnual">Yearly prices are per month, billed annually.</ng-container>
    <ng-container *ngIf="!isAnnual">Paid plans billed monthly carry a $300 cancellation fee within the first year.</ng-container>
  </p>

  <hr class="my-10 border-gray-200" />

  <div class="flex items-center justify-between gap-4">
    <button
      type="button"
      (click)="onBack()"
      class="inline-flex items-center gap-2 text-base font-medium text-gray-700 hover:text-gray-900"
    >
      <span aria-hidden="true">&larr;</span> Back
    </button>
    <div class="flex items-center gap-6">
      <span class="hidden text-xs font-semibold uppercase tracking-widest text-gray-400 sm:block">
        No card required today
      </span>
      <button
        type="button"
        class="btn-brand"
        (click)="onContinue()"
        [disabled]="!selectedPlanName"
      >
        Continue
      </button>
    </div>
  </div>
</div>
